'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSmokingRooms = function MdSmokingRooms(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.7 17c3.1 0 5.8 2.2 5.8 5.3v2.7h-2.5v-2.2c0-2.2-1.6-3.3-3.3-3.3h-2.6c-3 0-5.5-2.6-5.5-5.7s2.5-5.5 5.5-5.5v2.5c-1.7 0-3 1.2-3 2.9s1.3 3.3 3 3.3h2.6z m4.7-4.1c3.1 1.5 5.2 4.7 5.2 8.4v3.7h-2.5v-3.7c0-3.8-2.8-6.8-6.6-6.8v-2.5c1.7 0 3.1-1.4 3.1-3.1s-1.4-3-3.1-3v-2.5c3.1 0 5.6 2.5 5.6 5.5 0 1.6-0.7 3-1.7 4z m-1.4 13.7h2.5v5h-2.5v-5z m4.1 0h2.5v5h-2.5v-5z m-30.7 0h25v5h-25v-5z' })
        )
    );
};

exports.default = MdSmokingRooms;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/smoking-rooms.js
// module id = 3799
// module chunks = 168707334958949